import React, { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface PriorityAccessModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const PriorityAccessModalContext = createContext<
  PriorityAccessModalContextType | undefined
>(undefined);

interface PriorityAccessModalProviderProps {
  children: ReactNode;
}

export const PriorityAccessModalProvider: React.FC<
  PriorityAccessModalProviderProps
> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsOpen(false);
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'unset';
  };

  const value = {
    isOpen,
    openModal,
    closeModal,
  };

  return (
    <PriorityAccessModalContext.Provider value={value}>
      {children}
    </PriorityAccessModalContext.Provider>
  );
};

export const usePriorityAccessModal = () => {
  const context = useContext(PriorityAccessModalContext);
  if (context === undefined) {
    throw new Error(
      'usePriorityAccessModal must be used within a PriorityAccessModalProvider'
    );
  }
  return context;
};
